<template>
  <div class="comp-container">
    <div class="left-box">
      <div class="user-icon">
        <img v-if="gambleUserInfo.icon" :src="gambleUserInfo.icon" />
      </div>
      <div class="top-left">
        <div class="text">
          <span class="user-name">{{ gambleUserInfo.name }}</span>
          <span class="user-gold"
            ><i class="icon icon-gold-2 icon" /><span class="num">{{
              gambleUserInfo.gold || 0
            }}</span></span
          >
        </div>
        <div class="btn">
          <div class="btn-box" @click="showTask = true">
            <i
              class="icon icon-gold-2-light"
              :class="hasNewTask ? 'flash-effect jump-animation' : ''"
            />
            <span>{{ getDict(214) /*领取竞猜币*/ }}</span>
            <div class="dot" v-if="hasNewTask"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-box">
      <div class="help" @click="showRule">?</div>
      <div
        class="btn"
        v-for="(btn, index) in rightBtnNameList || []"
        :key="index"
        @click="clickBtn(btn)"
      >
        {{ btn.name }}
      </div>
    </div>
    <goldTask class="pop-box-hide" v-if="showTask" @close="showTask = false" />
  </div>
</template>

<script>
import { getDict, axios, webSocket } from "../../../../common";
import { mapState, mapGetters } from "vuex";
import goldTask from "./../gold-task";
import store from "@/store";
export default {
  name: "topIndo",
  props: {
    rightBtnNameList: {},
  },
  data() {
    return {
      // goldCount:123,
      // name:'test',
      // userIcon:'https://nie.res.netease.com/r/pic/20200603/187bb5a3-5d56-4577-b2f7-552f83c10846.png',

      showTask: false,
    };
  },
  computed: {
    ...mapGetters(["gambleUserInfo", "gambleTaskList"]),
    hasNewTask() {
      return !!this.gambleTaskList.find((task) => task.state == 1);
    },
  },
  watch: {},
  methods: {
    getDict,
    clickBtn(btn) {
      this.$emit("clickBtn", btn.key);
    },
    showRule() {
      this.$emit("showRule");
    },
    popTask() {
      this.showTask = true;
    },
  },
  components: {
    goldTask,
  },
  mounted() {},
  created() {
    store.dispatch("gambleGetTaskList");
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
  .left-box {
    z-index: 0;
    position: relative;
    $left-box-height: 0.53rem;
    $user-icon-size: 0.7rem;
    .user-icon {
      z-index: 5;
      position: absolute;
      left: 0;
      top: ($left-box-height - $user-icon-size)/2;
      width: $user-icon-size;
      height: $user-icon-size;
      border: 0.03rem solid #000;
      border-radius: 100%;
      // box-sizing: content-box;
      background-color: #fff;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0.01rem solid #ff0;
        border-radius: 100%;
      }
    }
    .top-left {
      background: url(./imgs/pic-left.png) no-repeat;
      background-size: auto 100%;
      background-position: left;
      width: $left-box-height * (630/53); //原来图片是(593/53)，宽度不够，现在加宽;
      height: $left-box-height;
      position: relative;
      left: $user-icon-size * 0.6;
      .text {
        $height: 0.45rem;
        position: absolute;
        left: 0.45rem;
        bottom: 0;
        height: $height;
        width: 2rem;
        line-height: $height;
        font-size: 0.2rem;
        .user-name {
          color: #292829;
          line-height: 1em;
          position: absolute;
          bottom: 100%;
        }
        .user-gold {
          color: #fff;
          display: flex;
          align-items: center;
          .icon {
            font-size: 1.2em;
          }
          .num {
            display: inline-block;
            transform: skew(-20deg);
            font-size: 0.24rem;
            font-weight: 600;

            background-image: -webkit-linear-gradient(
              -104deg,
              #5c1413,
              #e04445
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
      .btn {
        //transform:skewX(24deg);
        $dot-size: 0.1rem;
        position: absolute;
        // left: 3.2rem;
        left: 3.27rem;
        bottom: 0;
        $skewX: 24deg;
        padding-top: $dot-size;
        transform: skewX(-$skewX);
        overflow: hidden;
        // color: #502d16;
        .btn-box {
          position: relative;
          transform: skewX($skewX);
          font-size: 0.24rem;
          font-weight: 600;
          // background: url(./imgs/gold-btn.png) ;
          background: url(./imgs/gold-btn-bg.png);
          background-size: cover;
          background-position: center;
          // width:$left-box-height * (196/53);
          height: $left-box-height;

          display: flex;
          justify-content: center;
          align-items: center;
          $cut: 0.12rem;
          padding-left: $cut + 0.1rem;
          padding-right: $cut + 0.2rem;
          margin-left: -$cut;
          margin-right: -$cut;
          span {
            background-image: -webkit-linear-gradient(
              -104deg,
              #5c1413,
              #e04445
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          /* &::before {
            z-index: -1;
            $size: 0.2rem;
            height: $size;
            right: $cut + 0.15rem;
            width: $size * 2;
            content: "";
            background: url(./imgs/btn-deck.png);
            background-size: 100% auto;
            position: absolute;
            bottom: 0;
          } */
        }
        .icon {
          font-size: 1.5em;
        }
        .dot {
          position: absolute;
          right: 0.15rem;
          top: 0px;
          $size: $dot-size;
          width: $size;
          height: $size;
          background-color: #c90e0e;
          border-radius: 100%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .right-box {
    $right-box-height: 0.4rem;
    height: $right-box-height;
    display: flex;
    align-items: center;
    .btn,
    .help {
      color: #fff;
      height: $right-box-height;
      line-height: $right-box-height;
      background-color: rgba(#ededf5, 0.1);
      font-size: 0.26rem;
      display: inline-block;
      margin-left: 0.4rem;

      position: relative;
      &::after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 0.01rem rgba(#ffeb77, 0.5) solid;

        mask: linear-gradient(
          -40deg,
          #000 0%,
          rgba(0, 0, 0, 0.2) 30%,
          rgba(0, 0, 0, 0.2) 60%,
          #000 100%
        );
      }
    }
    .help {
      width: $right-box-height;

      text-align: center;
    }
    .btn {
      padding: 0 0.2rem;
      font-size: 0.2rem;
    }
  }
  .pop-box-hide {
    position: absolute;
    width: 0;
    height: 0;
    margin: 0;
  }

  .jump-animation {
    animation: move-jump-animation 2s infinite linear;
  }
  @-webkit-keyframes move-jump-animation {
    0% {
      transform: translateY(0%);
    }
    25% {
      transform: translateY(10%);
    }
    75% {
      transform: translateY(-10%);
    }
    100% {
      transform: translateY(0%);
    }
  }
}
</style>
